import classNames from 'classnames';
import { motion } from 'framer-motion';
import React from 'react';

import { IPurposeMap } from '../../api/charts/soulMatrix';

import PurposeMapCard from './PurposeMapCard';
import PurposeMapCardDiagram from './PurposeMapDiagram';
import PurposeMapSection from './PurposeMapSection';
import styles from './PurposeMap.module.scss';

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 },
};

export interface PurposeMapProps {
  data: IPurposeMap;
  highlightedIDs?: number[];
}

export function PurposeMap({ data, highlightedIDs }: PurposeMapProps) {
  const isHighlighted = (id: string): boolean => {
    if (!highlightedIDs || highlightedIDs.length === 0) return false;

    return highlightedIDs.includes(parseInt(id, 10));
  };

  return (
    <div className={styles.map}>
      <motion.div className={styles.lines} variants={containerVariants} initial="hidden" animate="visible">
        <motion.div variants={itemVariants}>
          <PurposeMapSection
            title="МУЖСКОЙ РОД"
            circles={[
              { id: '33', value: data.male_genetic_program_arcanes[0], isHighLighted: isHighlighted('33') },
              { id: '34', value: data.male_genetic_program_arcanes[1], isHighLighted: isHighlighted('34') },
              { id: '35', value: data.male_genetic_program_arcanes[2], isHighLighted: isHighlighted('35') },
            ]}
          />
        </motion.div>
        <motion.div variants={itemVariants}>
          <PurposeMapSection
            title="ЖЕНСКИЙ РОД"
            circles={[
              { id: '36', value: data.female_genetic_program_arcanes[0], isHighLighted: isHighlighted('36') },
              { id: '37', value: data.female_genetic_program_arcanes[1], isHighLighted: isHighlighted('37') },
              { id: '38', value: data.female_genetic_program_arcanes[2], isHighLighted: isHighlighted('38') },
            ]}
          />
        </motion.div>
      </motion.div>
      <hr />
      <motion.div className={styles.cards} variants={containerVariants} initial="hidden" animate="visible">
        <motion.div variants={itemVariants}>
          <PurposeMapCard
            title={'ПОИСК СЕБЯ'}
            description={`Соединение мужского и женского. Выстраивание взаимоотношений. Способности, навыки, умения.`}
          >
            <PurposeMapCardDiagram
              top={{
                id: '39',
                label: 'Небо',
                value: data.self_search.sky,
                isHighLighted: isHighlighted('39'),
              }}
              right={{
                id: '41',
                value: data.self_search.purpose,
                isHighLighted: isHighlighted('41'),
              }}
              bottom={{
                id: '40',
                label: 'Земля',
                value: data.self_search.earth,
                isHighLighted: isHighlighted('40'),
              }}
            />
          </PurposeMapCard>
        </motion.div>
        <motion.div variants={itemVariants}>
          <PurposeMapCard
            title={'СОЦИАЛИЗАЦИЯ'}
            description={`Социальная и родовая системы. Результаты и признания в социуме.`}
          >
            <PurposeMapCardDiagram
              top={{
                id: '42',
                label: 'М',
                value: data.socialization.male,
                isHighLighted: isHighlighted('42'),
              }}
              right={{
                id: '44',
                value: data.socialization.social,
                isHighLighted: isHighlighted('44'),
              }}
              bottom={{
                id: '43',
                label: 'Ж',
                value: data.socialization.female,
                isHighLighted: isHighlighted('43'),
              }}
            />
          </PurposeMapCard>
        </motion.div>
        <motion.div variants={itemVariants}>
          <PurposeMapCard
            title={'ДУХОВНЫЕ ЗНАНИЯ'}
            description={`Духовный зачет. Кто я для бога? Где божественное во мне?`}
          >
            <div
              className={`${styles.cardCalculation__circle} ${classNames({ [styles.active]: isHighlighted('45') })}`}
              id="45"
            >
              {data.soul_knowledge}
            </div>
          </PurposeMapCard>
        </motion.div>
      </motion.div>
    </div>
  );
}
